"use strict";
import React from "react";
import "art/modes/dom";
import { Group } from "react-art";
import Rectangle from "react-art/shapes/rectangle";
import Vector from "immutable-vector2d";
const RedactionElement = (props) => {
  return /* @__PURE__ */ React.createElement(Group, { x: props.x, y: props.y }, /* @__PURE__ */ React.createElement(
    Rectangle,
    {
      width: props.width,
      height: props.height,
      cursor: props.annotating ? "move" : "default",
      stroke: props.selected ? "#aaa" : "#ddd",
      strokeWidth: props.annotating ? 2 : 0,
      fill: "#fff"
    },
    "REDACTED"
  ));
};
RedactionElement.calculateDragPoints = function(x, y, width, height) {
  return [
    { x, y },
    { x: x + width, y },
    { x: x + width, y: y + height },
    { x, y: y + height }
  ].map(Vector.fromObject);
};
RedactionElement.typeID = "Redaction";
RedactionElement.displayName = "Redaction";
RedactionElement.getBoundingBox = function(dragPoints) {
  const multipliers = [
    [-1, -1],
    [1, -1],
    [1, 1],
    [-1, 1]
  ];
  return dragPoints.map((point, idx) => {
    return [point.x + multipliers[idx][0], point.y + multipliers[idx][1]];
  });
};
export default RedactionElement;
